import React from "react";
import { FiShoppingCart } from "react-icons/fi";
import LogoSvg from "../../icons-svg/AKEAD-Logo_white-simple.svg";

const MAIN_COLOR = "rgb(29, 71, 127)";

const Header = ({ cartCount = 0, onCartClick, language = "tr" }) => {
  const lang = String(language || "tr").toLowerCase().slice(0, 2);

  const titleMap = {
    tr: "Mağaza",
    en: "Shop",
    fr: "Boutique",
    de: "Shop",
    nl: "Winkel",
  };

  const title = titleMap[lang] || titleMap.tr;

  return (
    <header
      className="sticky top-0 z-40 border-b border-slate-200"
      style={{ backgroundColor: MAIN_COLOR }}
    >
      <div className="mx-auto w-full max-w-[1880px] px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-12">
        <div className="flex h-16 items-center justify-between">

          {/* LEFT SIDE */}
          <div className="flex items-center gap-2 min-w-0 shrink-0 leading-none">
            
            {/* LOGO */}
            <img
              src={LogoSvg}
              alt="AKEAD"
              className="h-5 sm:h-6 object-contain"
            />

            {/* TEXT */}
            <span className="text-[22px] sm:text-[26px] font-semibold tracking-tight text-white">
              {title}
            </span>
          </div>

          {/* CART BUTTON */}
          <button
            type="button"
            onClick={onCartClick}
            className="relative flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20"
            aria-label="cart"
          >
            <FiShoppingCart size={18} />

            {cartCount > 0 && (
              <span className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-white px-1 text-[11px] font-bold text-[rgb(29,71,127)] shadow">
                {cartCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;